import { render, staticRenderFns } from "./activityBase.vue?vue&type=template&id=33a84fe6&scoped=true"
import script from "./activityBase.vue?vue&type=script&lang=js"
export * from "./activityBase.vue?vue&type=script&lang=js"
import style0 from "./activityBase.vue?vue&type=style&index=0&id=33a84fe6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a84fe6",
  null
  
)

export default component.exports